import CategoryGrid from '../../../components/CategoryGrid/CategoryGrid'
import { useAppStore } from '../../../store/useAppStore'

/**
 * Главная для пользователя без подписки — прежний вид: блок «Доступный
 * материал» и подборка «Материалы в подписке».
 *
 * Новые блоки главной бесплатному пользователю пусты: разделы и поиск ему
 * закрыты (`useCategories` не запрашивается без подписки), недавнего ещё нет,
 * курсы заблокированы. Из-за этого главная выглядела полупустой, а доступные
 * рецепты вообще не показывались — поэтому здесь оставлен старый грид.
 */
const FreeHomeContent = () => {
  const { searchQuery } = useAppStore()

  return <CategoryGrid section="" searchQuery={searchQuery} />
}

export default FreeHomeContent
